import { Box, BoxProps, ColorOptions, MaterialTextInput, expiry as validateExpiry } from '@jfs/ui-new'
import { useState } from 'react'
import { convertHexToRGBA, formatExpiryDate, getExpiryMessage } from '../../../utils'

interface ExpiryCVVInputProps {
  value?: string
  onChange: (value: string) => void
  theme?: any
}

const creditCardStyles = (merchantTheme: any) => ({
  errorContainer: {
    height: '20px',
    direction: 'row',
    align: 'center',
  } as BoxProps,
  container: {
    // bg: 'BG_PRIMARY',
  } as BoxProps,
  creditCardContainer: {
    direction: 'column',
  } as BoxProps,
  cardContainer: {
    direction: 'row',
    align: 'center',
  } as BoxProps,
  cvvContainer: {
    direction: 'row',
    align: 'center',
  } as BoxProps,
  cardHolderContainer: {
    direction: 'row',
    align: 'center',
  } as BoxProps,
  conatiner: {
    height: '100%',
    align: 'center',
    justify: 'space-between',
    flexDirection: 'column',
  } as BoxProps,
  mobileContainer: (isEnoughSpace: any) =>
    ({
      height: '100%',
      flex: 1,
      overflowY: isEnoughSpace ? 'unset' : 'scroll',
      bg: merchantTheme?.bodyBgColor as ColorOptions,
    } as BoxProps),
  innerContainer: {
    width: '530px',
    p: 'SMALL',
    bg: 'BG_WHITE',
    alignSelf: 'center',
  } as BoxProps,
  mobileInnerContainer: {
    flexGrow: 1,
    p: 0,
    bg: merchantTheme?.bodyBgColor as ColorOptions,
    alignSelf: 'stretch',
  } as BoxProps,
})

const Expiry = ({ value, onChange, theme }: ExpiryCVVInputProps) => {
  const [errorMsgExpiry, setErrorMsgExpiry] = useState('')
  const styles = creditCardStyles(theme)

  const internalOnChangeExpiry = async (text: string) => {
    errorMsgExpiry && setErrorMsgExpiry('')
    const numberWithoutSpace = text.replace(/[^0-9]/g, '')
    const formattedExpiry = formatExpiryDate(numberWithoutSpace)

    if (formattedExpiry.length !== 7) {
    } else {
      validateExpiry.validate(formattedExpiry.replace(' / ', '/')).catch(() => {
        setErrorMsgExpiry(getExpiryMessage(formattedExpiry))
      })
    }

    onChange(formattedExpiry)
  }

  const onInternalExpiryBlur = () => {
    if (!value || value.length < 7) {
      setErrorMsgExpiry('Invalid expiry date')
    }
  }

  return (
    <Box {...styles.cvvContainer}>
      <MaterialTextInput
        maxLength={7}
        value={value}
        onChangeText={(text: string) => internalOnChangeExpiry(text)}
        onBlur={onInternalExpiryBlur}
        placeholderTextColor={convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions}
        placeholder={'Expiry (MM/YY)'}
        color={theme?.bodyTextColor}
        keyboardType={'number-pad'}
        error={errorMsgExpiry}
        testID={'expiryDateTextInput'}
        bottomLineColor={theme?.brandColor as ColorOptions}
        tintColor={theme?.brandColor as ColorOptions}
      />
    </Box>
  )
}

export { Expiry }
